module.exports = __webpack_public_path__ + "static/img/ia_100000000.b2e6132b.png";